import * as React from 'react';

import { DataGridColumn } from '@rematter/ui-web';

import { useTranslations } from '../../../i18n/useTranslations';
import { WorkOrderInputItemRecord } from '../../../types/workOrder';

export const useWorkOrderInputItemsColumns =
  (): DataGridColumn<WorkOrderInputItemRecord>[] => {
    const t = useTranslations();

    return React.useMemo(
      () => [
        {
          key: 'item',
          header: t.workOrderDetailView.inputItems.table.columns.item,
          cell: ({ row }) => <span>{row.itemName || row.itemId}</span>,
          width: 200,
        },
        {
          key: 'lot',
          header: t.workOrderDetailView.inputItems.table.columns.lot,
          cell: ({ row }) => <span>{row.lotNumber || '—'}</span>,
          width: 150,
        },
        {
          key: 'tag',
          header: t.workOrderDetailView.inputItems.table.columns.tag,
          cell: ({ row }) => <span>{row.tagNumber || '—'}</span>,
          width: 150,
        },
        {
          key: 'plannedQty',
          header:
            t.workOrderDetailView.inputItems.table.columns.plannedQuantity,
          cell: ({ row }) => (
            <span>
              {row.plannedQuantityValue.toLocaleString()}{' '}
              {row.plannedQuantityUnit}
            </span>
          ),
          width: 150,
        },
        {
          key: 'actualQty',
          header: t.workOrderDetailView.inputItems.table.columns.actualQuantity,
          cell: ({ row }) => (
            <span>
              {row.actualQuantityValue
                ? `${row.actualQuantityValue.toLocaleString()} ${row.actualQuantityUnit}`
                : '—'}
            </span>
          ),
          width: 150,
        },
        {
          key: 'notes',
          header: t.workOrderDetailView.inputItems.table.columns.notes,
          cell: ({ row }) => (
            <span className="text-neutral/60">{row.notes || '—'}</span>
          ),
          width: 200,
        },
      ],
      [t],
    );
  };
